import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Fires a GA4 page_view on every React Router navigation.
 *
 * `index.html` already loaded gtag.js + the initial `gtag('config', ...)` call,
 * which sends the FIRST page_view automatically. After that, React Router
 * navigates without reloading the document, so GA4 wouldn't see route changes
 * unless we tell it. This hook does exactly that — and only that.
 *
 * Render <GoogleAnalytics /> once near the top of the tree (inside
 * <BrowserRouter> so useLocation() is available).
 */
const GA_ID = 'G-VE6P55X09L';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    const path = location.pathname + location.search + location.hash;
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
      send_to: GA_ID,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default GoogleAnalytics;
